/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
import React, { Children, cloneElement, forwardRef, useState } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-unresolved
import classNames from 'classnames';
import Icon from '../icon/Icon';
import TagWrapper from '../TagWrapper';
import Collapse from './Collapse';
// import Checks from './forms/Checks';
// import FormGroup from './forms/FormGroup';

export const SectionAccordionItem = forwardRef(
	(
		{
			id,
			icon,
			title,
			children,
			tag,
			headerTag,
			overWriteColor,
			itemStyle,
			sectionIsComplete,
			sectionIsCurrent,
			sectionIsCrossedOut,
			currentSectionHeaderStyle,
			nonCurrentSectionHeaderStyle,
			checkStyle,
			collapseStyle,
			firstItemId,
			lastItemId,
			statusString,
			...props
		},
		ref,
	) => {
		const _selected = props.activeItem === id;
		// Create the header styles for this item
		// const headerStyle = {};
		// if (_selected) {
		// 	headerStyle.borderBottom = '1px solid #E5E5E5';
		// }
		// if (sectionIsCurrent) {
		// 	headerStyle.color = 'var(--brand-color)';
		// 	headerStyle.backgroundColor = 'var(--bs-accordion-active-bg)';
		// } else {
		// 	headerStyle.color = 'var(--bs-accordion-btn-color)';
		// 	headerStyle.backgroundColor = 'transparent';
		// }
		// if (sectionIsCrossedOut) {
		// 	/// Add styles that cross out and gray text
		// 	headerStyle.textDecoration = 'line-through';
		// 	headerStyle.color = '#6c757d';
		// 	headerStyle.backgroundColor = 'transparent';
		// }
		return (
			<TagWrapper
				tag={tag}
				ref={ref}
				className={classNames('accordion-item')}
				style={itemStyle}>
				<TagWrapper
					tag={headerTag}
					style={{
						borderBottom: `1px solid var(--bs-card-border-color)`,
					}}
					className={classNames('accordion-header')}
					id={id}>
					<button
						className={classNames('accordion-button', {
							collapsed: !_selected,
							[`accordion-button-${overWriteColor}`]: overWriteColor,
							'section-accordion-crossed-out-state': sectionIsCrossedOut,
							'section-accordion-is-complete': sectionIsComplete,
							'section-accordion-current-state': sectionIsCurrent,
							'section-accordion-non-current-state': !sectionIsCurrent,
						})}
						type='button'
						data-bs-toggle='collapse'
						data-bs-target={`#${id}Collapse`}
						aria-expanded={_selected}
						aria-controls={`${id}Collapse`}
						onClick={() => props.handleItemClick(id)}>
						{/* <FormGroup id={`optionGroup-${id}`}>
							<Checks
								style={{ marginRight: '1rem', ...checkStyle }}
								checked={sectionIsComplete || sectionIsCrossedOut}
								name={`option-${id}`}
								id={`option-${id}`}
								value={id}
								onChange={() => props.handleItemClick(id)}
							/>
						</FormGroup> */}
						{icon && <Icon icon={icon} className='accordion-icon' />}
						{title}
						{statusString && (
							<span style={{ fontWeight: '300', marginLeft: '0.75rem' }}>
								{statusString}
							</span>
						)}
					</button>
				</TagWrapper>
				<Collapse
					isOpen={_selected}
					id={`${id}Collapse`}
					className={classNames('accordion-collapse')}
					aria-labelledby={id}
					style={{ backgroundColor: '#f8f9fa' }}
					data-bs-parent={`#${props.parentId}`}>
					<div className={classNames('accordion-body')}>{children}</div>
				</Collapse>
			</TagWrapper>
		);
	},
);

SectionAccordionItem.propTypes = {
	/**
	 * Unique ID
	 */
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	/**
	 * Automatically added
	 */
	parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	/**
	 * Item title
	 */
	title: PropTypes.string.isRequired,
	/**
	 * Item Content
	 */
	children: PropTypes.node.isRequired,
	/**
	 * Item title icon
	 */
	icon: PropTypes.string,
	tag: PropTypes.oneOf(['div', 'section']),
	headerTag: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div', 'span', 'section']),
	/**
	 * If you have chosen color from the accordion's own properties, you can overwrite it with this.
	 */
	overWriteColor: PropTypes.oneOf([
		'primary',
		'secondary',
		'success',
		'info',
		'warning',
		'danger',
		'light',
		'dark',
	]),
	style: PropTypes.objectOf(PropTypes.string),
	sectionIsComplete: PropTypes.bool.isRequired,
	sectionIsCurrent: PropTypes.bool.isRequired,
	sectionIsCrossedOut: PropTypes.bool.isRequired,
	itemStyle: PropTypes.object,
	activeSectionHeaderStyle: PropTypes.object,
	inactiveSectionHeaderStyle: PropTypes.object,
	checkStyle: PropTypes.object,
	collapseStyle: PropTypes.object,
	firstItemId: PropTypes.string,
	lastItemId: PropTypes.string,
	props: PropTypes.object.isRequired,
	statusString: PropTypes.string,
};
SectionAccordionItem.defaultProps = {
	parentId: null,
	icon: null,
	tag: 'div',
	headerTag: 'h2',
	overWriteColor: null,
	style: null,
	itemStyle: {},
	activeSectionHeaderStyle: {},
	inactiveSectionHeaderStyle: {},
	checkStyle: {},
	collapseStyle: {},
	firstItemId: null,
	lastItemId: null,
	statusString: '',
};
SectionAccordionItem.displayName = 'SectionAccordionItem';

const SectionAccordion = forwardRef(
	(
		{
			tag,
			id,
			activeItemId,
			setSelectedOption,
			children,
			shadow,
			color,
			isFlush,
			className,
			style,
		},
		ref,
	) => {
		// Make the first item active by default
		const [activeItem, setActiveItem] = useState(activeItemId || children.flat()[0].props.id);

		const handleItemClick = (itemId) => {
			setActiveItem(itemId);
			if (setSelectedOption) {
				setSelectedOption(itemId);
			}
		};

		// find first and last item id
		const firstItemId = children.flat()[0].props.id;
		const lastItemId = children.flat()[children.flat().length - 1].props.id;

		return (
			<TagWrapper
				tag={tag}
				ref={ref}
				style={style}
				className={classNames(
					'accordion',
					{
						'accordion-flush': isFlush,
						'shadow-none': isFlush,
						[`shadow${shadow !== 'default' ? `-${shadow}` : ''}`]: !!shadow,
					},
					className,
				)}
				id={id}>
				{Children.map(children, (child) =>
					['SectionAccordionItem'].includes(child.type.displayName) ? (
						cloneElement(child, {
							activeItem,
							handleItemClick,
							firstItemId,
							lastItemId,
							parentId: id,
							overWriteColor: child?.props?.overWriteColor || color,
						})
					) : (
						<code className='d-block'>
							Only SectionAccordionItem component should be used as a child.
						</code>
					),
				)}
			</TagWrapper>
		);
	},
);
SectionAccordion.propTypes = {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	/**
	 * By default, the first is enabled, you can enter the AcordionItem ID you want and make it appear active.
	 * If you don't want any of them to be active, you can give it "false".
	 */
	activeItemId: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
	children: PropTypes.node.isRequired,
	/**
	 * If checked true the shadow is cleared.
	 */
	isFlush: PropTypes.bool,
	className: PropTypes.string,
	tag: PropTypes.oneOf(['div', 'section']),
	shadow: PropTypes.oneOf([null, 'none', 'sm', 'default', 'lg']),
	/**
	 * Active item color
	 */
	color: PropTypes.oneOf([
		'primary',
		'secondary',
		'success',
		'info',
		'warning',
		'danger',
		'light',
		'dark',
	]),
	style: PropTypes.objectOf(PropTypes.string),
	setSelectedOption: PropTypes.func.isRequired,
};
SectionAccordion.defaultProps = {
	activeItemId: null,
	isFlush: false,
	className: null,
	tag: 'div',
	shadow: 'default',
	color: 'primary',
	style: null,
};

export default SectionAccordion;
